<template>
    <transition name="fade">
        <div v-if="tweet">
            <h2 class="mt-5">Replies</h2>

            <!--Sorting replies-->
            <form id="replySortForm" action="/" method="get" class="form-inline rounded border m-1 p-1">
                <div class="form-group mr-2 ml-1 mt-1 mb-1">
                    <label for="reply_sort" class="font-weight-bold mr-1">Sort from </label>
                    <select type="" id="reply_sort" class="form-control" @input="repliesSortSelectHandler($event)">
                        <option v-for="(sortValue, sortKey) in replySortOptions" :value="sortKey">{{sortValue}}</option>
                    </select>

                </div>
                <div class="form-group m-1">
                    <label for="reply_group_stance" class="font-weight-bold mr-1">Show stance </label>
                    <select type="" id="reply_group_stance" class="form-control" @input="repliesShowSelectHandler($event)">
                        <option v-for="(showValue, showKey) in replyShowStanceOptions" :value="showKey" style="text-transform: capitalize">{{showValue}}</option>
                    </select>

                </div>
                <div class="form-group m-1">
                    <label for="filter_verified" class="font-weight-bold mr-1">Accounts to show</label>
                    <select type="" id="filter_verified" class="form-control" @input="repliesAccountShowSelectHandler($event)">
                        <option value="all" style="text-transform: capitalize">All accounts</option>
                        <option value="verified" style="text-transform: capitalize">Verified Only</option>
                        <option value="unverified" style="text-transform: capitalize">Unverified Only</option>
                    </select>

                </div>
                <div class="form-group m-1">
                    <label for="replies_per_page" class="font-weight-bold mr-1">Replies to show </label>
                    <select v-model="repliesPerPage" type="" id="replies_per_page" class="form-control">
                        <option v-for="(showValue) in repliesPerPageOptions" :value="showValue">{{showValue}}</option>
                    </select>
                </div>
            </form>

            <template v-if="replies && replies.length > 0">
                <transition-group name="fade" tag="div">
                    <tweet-reply v-for="reply in paginatedReplies" :reply="reply" :key="reply.id_str"></tweet-reply>
                </transition-group>
                <paginate v-model="currentRepliesPage"
                    style="justify-content: center;"
                    :page-count="getPageCount"
                    :page-range="5"
                    :margin-pages="1"
                    :click-handler="clickCallback"
                    :prev-text="'<'"
                    :next-text="'>'"
                    :container-class="'pagination'"
                    :first-last-button="true"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :break-view-class="'break-view'"
                    :break-view-link-class="'break-view-link'"
                    >
                </paginate>
            </template>
            <div v-else-if="fetchingReplies" class="m-3 text-center">
                <p class="font-weight-bold">
                    <span class="spinner-grow spinner-grow-sm mr-2" role="status" aria-hidden="true"></span>
                    Fetching replies ...
                </p>
            </div>
            <p v-else class="m-3">No replies</p>

            <!-- Modal -->
            <div class="modal fade" id="stanceHelpModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                 aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Stance Classification</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p>
                                Each reply to a tweet has a stance, an opinion the reply has towards the original tweet.
                                This service classes stance into four categories, Support (Green), Deny (Red), Comment
                                (Blue), and Question (Yellow).
                            </p>
                            <p>
                                Automatically categorised stance is shown on the bottom left and its corresponding
                                colour is used as the tweet's background. Darker background colour indicates more
                                confidence in the classification.
                            </p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </transition>

</template>

<script>
    import TweetReply from "./TweetReply";
    import { mapState, mapGetters, mapActions } from 'vuex'

    const axios = require('axios').default;
    let axios_cancel = null;

    export default {
        name: "TweetReplies",
        components: {TweetReply},
        data() {
            return {
                currentRepliesPage: 1,
                repliesPerPage: 5
            }
        },
        computed: {
            ...mapState(["tweet", "replies", "fetchingReplies", "replySortOptions", "replyAccountShow"]),
            ...mapGetters(["replyShowStanceOptions", "sortedReplies"]),
            paginatedReplies: function() {
                var start =  (Number(this.currentRepliesPage) - 1) * Number(this.repliesPerPage);
                var end = start + Number(this.repliesPerPage);
                let output = this.sortedReplies.slice(start,end)
                if (Array.isArray(output) && output.length === 0){
                    output = this.sortedReplies.slice(0,this.repliesPerPage);
                    this.currentRepliesPage = 1;
                }
                return output;
            },
            getPageCount: function() {
                return Math.ceil(Number(this.sortedReplies.length) / Number(this.repliesPerPage));
            },
            repliesPerPageOptions: function() {
                if (this.sortedReplies){
                    const choices = [2, 5, 10, 100]; // possible choices of replies to display per page
                    const maxReplies = this.sortedReplies.length;
                    var result = choices.filter(choice => choice < maxReplies); //returns elements of choices < total number of replies
                    result.push(maxReplies); //puts the max value on the end
                    return result;
                }else{
                    return 0;
                }
            }
        },
        methods: {
            ...mapActions(["updateReplies", "updateRepliesShowOption", "updateRepliesSortOption", "updateRepliesAccountShowOption"]),
            repliesShowSelectHandler(event){
                this.updateRepliesShowOption(event.target.value);
            },
            repliesAccountShowSelectHandler(event){
                this.updateRepliesAccountShowOption(event.target.value);
            },
            repliesSortSelectHandler(event){
                this.updateRepliesSortOption(event.target.value);
            },
            clickCallback(pageNum){
                this.currentRepliesPage = Number(pageNum);
            }
        },

    }
</script>

<style scoped>

</style>
